import { Modal, Spin } from 'antd';
import React, { useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router';
import useFacility from '../../../queries/useFacility';
import useTariffsTypes from '../../../queries/useTariffsTypes';
import createFacilityTariffs from '../../../requests/createFacilityTariffs';
import AddTariffFields from '../../AddTariffFields/AddTariffFields';

const AddTariffsModal = ({ visible, onOk, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const { facilityId } = useParams();
  const [tariffs, setTariffs] = useState([]); // {type, value} type - key из tariffTypes, value - буквально имя тарифа, см. tariffTypes
  const { isFetching: tariffTypesFetching } = useTariffsTypes();
  const { data: facility, isFetching: facilityFetching } =
    useFacility(facilityId);
  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setLoading(true);
      await createFacilityTariffs(tariffs, facility);
      setLoading(false);
      onOk();
    },
    [tariffs, facility]
  );
  const onClose = useCallback(() => {
    if (!loading) {
      onCancel();
      setTariffs([]);
    }
  }, [onCancel, loading]);

  const cancelButtonProps = useMemo(
    () => ({
      disabled: loading,
    }),
    [loading]
  );
  const okButtonProps = useMemo(
    () => ({
      disabled:
        loading ||
        tariffTypesFetching ||
        facilityFetching ||
        tariffs.some((item) => Boolean(item.error) || item.notIndicated),
    }),
    [loading, tariffTypesFetching, facilityFetching, tariffs]
  );
  return (
    <Modal
      title="Добавить тарифы"
      visible={visible}
      onOk={handleSubmit}
      onCancel={onClose}
      width={650}
      okButtonProps={okButtonProps}
      cancelButtonProps={cancelButtonProps}
      okButtonText="Сохранить"
    >
      <Spin spinning={loading || tariffTypesFetching}>
        <AddTariffFields tariffs={tariffs} setTariffs={setTariffs} />
      </Spin>
    </Modal>
  );
};

export default AddTariffsModal;
